import { DefaultButton, DocumentCardImage, ImageFit, Link, TextField } from '@fluentui/react';
import { baseUrlAdmin } from '../../../../../constants/url.constant';
import { textFieldStyles } from '../../../../common/views/DefaultStyles';
import { Utils } from '../../../../common/views/Utils';
import AddPictureView from '../../../../pictures/views/AddPictureView';
import { UploadPictureModel } from '../../../../pictures/models/PictureModel';
import { EditProductModel } from '../../../../products/models/ProductModel';
import { ProductUtils } from '../../../../products/views/ProductUtils';
import { OrderModel } from '../../../models/OrderModel';

type EditOrderProductProps = {
    order: OrderModel;
    form: EditProductModel;
    errorMessages: any;
    loading: boolean;
    showPicture: boolean;
    setShowPicture: (value: boolean) => void;
    onAddPicture: (picture: UploadPictureModel) => void;
    onValueChange: (field: keyof EditProductModel, value: any) => void;
    onSubmit: (id: number) => void;
}

export default function EditOrderProductView({
    order, form, errorMessages, onSubmit, loading, showPicture,
    setShowPicture, onAddPicture, onValueChange
}: EditOrderProductProps) {
    const width4 = Utils.getColumnWidth(4, 12, 12);
    const width6 = Utils.getColumnWidth(6)
    const width8 = Utils.getColumnWidth(8, 12, 12);

    const onProductDetail = () => {
        if (order.product && order.product.link) {
            window.open(order.product.link, "_blank");
        } else {
            alert("Product link not available.");
        }
    }

    const pictureElement = () => {
        const url = order && order.product ?
            ProductUtils.getImageUrl(baseUrlAdmin, order.product.picture) : "";

        var size = Utils.pictureFileSizes["Feature"];
        if (!size || !size.height) size = { width: 200, height: 200 };

        if (Utils.isNullOrEmpty(url)) return <></>;

        return <div className="pointer" onClick={onProductDetail}>
            <DocumentCardImage
                height={size.height}
                imageFit={ImageFit.centerCover}
                className="product-picture image-radius cur"
                imageSrc={url}
            />
        </div>
    }

    const nameInput = () => {
        return <>
            <TextField
                label="Name"
                value={form.name}
                onChange={(_, v) => onValueChange("name", v || "")}
                errorMessage={errorMessages.phoneNo}
                styles={textFieldStyles} />
        </>;
    }

    const descriptionInput = () => {
        return <>
            <TextField
                label="Description"
                value={form.description}
                onChange={(_, v) => onValueChange("description", v || "")}
                errorMessage={errorMessages.description}
                styles={textFieldStyles} />
        </>;
    }

    const weightInput = () => {
        return <>
            <TextField
                label="Weight"
                value={form.weight.toString()}
                onChange={(_, v) => onValueChange("weight", v || 0)}
                errorMessage={errorMessages.weight}
                styles={textFieldStyles} />
        </>;
    }

    const dimensionInput = () => {
        return <>
            <TextField
                label="Dimension"
                value={form.dimension}
                onChange={(_, v) => onValueChange("dimension", v || "")}
                styles={textFieldStyles}
                errorMessage={errorMessages.dimension} />
        </>;
    }

    const linkInput = () => {
        return <>
            <TextField
                label="Link"
                value={form.link}
                onChange={(_, v) => onValueChange("link", v || "")}
                multiline rows={2}
                errorMessage={errorMessages.link} />
        </>;
    }

    const noteInput = () => {
        return <>
            <TextField
                label="Note"
                value={form.note}
                onChange={(_, v) => onValueChange("note", v || "")}
                multiline rows={2}
                errorMessage={errorMessages.note} />
        </>;
    }

    const productForm = () => {
        return <div>
            <div>{nameInput()}</div>
            <div className="pt-10">{descriptionInput()}</div>

            <div className="ms-Grid pt-10">
                <div className={width6} style={{ paddingLeft: 0 }}>
                    {weightInput()}
                </div>
                <div className={width6} style={{ paddingRight: 0 }}>
                    {dimensionInput()}
                </div>
            </div>
        </div>;
    }

    return <>
        <div className="ms-Grid-row">
            <div className={width4 + " center"}>
                {pictureElement()}
                <Link onClick={() => setShowPicture(true)}>Select Photo</Link>
            </div>
            <div className={width8}>
                {productForm()}
            </div>
        </div>

        <div className="ms-Grid-row ph-10">
            <div className="pt-10">{linkInput()}</div>
            <div className="pt-10">{noteInput()}</div>
        </div>

        {!loading && <div className="pt-15 right">
            <DefaultButton onClick={() => onSubmit(order.id)}>
                Save Change
            </DefaultButton>
        </div>}

        {showPicture && <>
            <AddPictureView
                onSubmit={onAddPicture}
                onClose={() => setShowPicture(false)}
            />
        </>}
    </>;
}